import React from 'react'
import classNames from 'classnames'
import { buttonHtmlType, buttonType } from './Button-types'
import './Button.sass'
import {
  BUTTON_DANGER,
  BUTTON_DARK,
  BUTTON_PRIMARY,
  BUTTON_TRANSPARENT,
} from './Button-constants'

interface ButtonProps {
  className?: string
  type?: buttonType
  htmlType?: buttonHtmlType
  autoFocus?: boolean
  disabled?: boolean
  loading?: boolean
  children?: React.ReactNode
  onClick?: (x: any) => void
}

export const Button: React.FC<ButtonProps> = (props) => {
  const {
    className,
    htmlType = 'button',
    type = 'primary',
    loading = false,
    disabled = false,
    onClick,
    ...rest
  } = props
  const buttonPrfx = 'btn'
  const buttonCls = classNames(buttonPrfx, {
    [`${buttonPrfx}_type_${BUTTON_PRIMARY}`]: type === BUTTON_PRIMARY,
    [`${buttonPrfx}_type_${BUTTON_DARK}`]: type === BUTTON_DARK,
    [`${buttonPrfx}_type_${BUTTON_TRANSPARENT}`]: type === BUTTON_TRANSPARENT,
    [`${buttonPrfx}_type_${BUTTON_DANGER}`]: type === BUTTON_DANGER,
    [`${className}`]: className,
  })
  return (
    <button
      className={buttonCls}
      type={htmlType}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {loading ? 'Подождите...' : props.children}
    </button>
  )
}
